import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  events: localStorage.getItem('configurations') && JSON.parse(localStorage.getItem('configurations'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/configurations/index.js